import { render, staticRenderFns } from "./DeleteScheduledMessage.vue?vue&type=template&id=6bcf1631&"
import script from "./DeleteScheduledMessage.vue?vue&type=script&lang=js&"
export * from "./DeleteScheduledMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports